import React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import History from "../../utilities/History";
import { Dropdown, DropdownOption } from "@abb/abb-common-ux-react";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";

interface ICalculatedPropertyProps {
    selectedCalculatedProperties: any[];
    calculateChangeHandler: any;
    allCalculatedDropdownList: any[];
}

export default class CalculatedProperty extends React.Component<ICalculatedPropertyProps, {}> {
    private _mount: boolean = false;

    constructor(props: ICalculatedPropertyProps) {
        super(props);
        this._mount = true;

    }

    componentWillUnmount() {
        this._mount = false;
    }

    componentDidMount() {
        this._mount = true;
    }

    public render() {
        return (
            <Translation>
                {(t) => (
                    <React.Fragment>
                        <Dropdown
                            multiselect={true}
                            label={t(CONSTANTS.CALCULATED_PROPERTIES)}
                            allowAdd={false}
                            clearable={false}
                            placeholder={t(
                                CONSTANTS.NO_CALCULATED_PROPERTY_SELECTED
                            )}
                            searchable={true}
                            value={this.props.selectedCalculatedProperties}
                            onChange={(value) =>
                                this.props.calculateChangeHandler(value)
                            }
                        >
                            {this.props.allCalculatedDropdownList.map(
                                (o: any, index: any) => (
                                    <DropdownOption
                                        key={index}
                                        label={o.label}
                                        value={o.value}
                                        disabled={o.disabled}
                                    />
                                )
                            )}
                        </Dropdown>
                    </React.Fragment >
                )
                }
            </Translation>
        );
    }
}

